import { AppThunk } from '../../../index';

/**
 * `emailVerified` is baked into the cached ID token, so it does not flip on its
 * own once the user clicks the link (often in another tab). Reloading the user
 * refetches the Auth record; resolves to the fresh flag so the caller can react.
 */
export const refreshEmailVerified =
  (): AppThunk<Promise<boolean>> =>
  async (_dispatch, _getState, { auth }) => {
    const user = auth().currentUser;

    if (!user) {
      return false;
    }

    try {
      await user.reload();

      return auth().currentUser?.emailVerified ?? false;
    } catch {
      return false;
    }
  };
